import { Badge as AntdBadge, Menu as AntdMenu, Typography } from "antd";

import styled from "styled-components";

export const Menu = styled(AntdMenu)`
  float: right;
  background-color: ${({ theme }) => theme.token.colorFillTertiary};
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  height: 74px;
  width: 180px;

  @media (min-width: 576px) {
    width: 280px;
  }

  .ant-menu-submenu {
    height: 100%;
    width: 100%;
    padding: 0;
  }

  .ant-menu-submenu-title {
    display: flex;
    align-items: flex-start;
    height: 100%;

    .ant-menu-title-content {
      display: flex;
      align-items: center;
      height: 100%;
      width: 100%;
      padding: 8px 20px 8px 26px;
    }
  }
`;

export const MenuText = styled(Typography.Text).attrs({
  type: "secondary",
  ellipsis: true,
})`
  line-height: initial;
`;

export const Submenu = styled.div`
  ul {
    background-color: ${({ theme }) => theme.token.colorPrimary} !important;
    box-shadow: none !important;

    span {
      color: white !important;
    }
  }
`;

export const Badge = styled(AntdBadge).attrs(({ theme, color }) => ({
  color: color || theme.token.colorPrimary,
}))`
  z-index: 2;
  /* border-color: ${({ theme, color }) =>
    color || theme.token.colorPrimary} !important; */
`;

export const Score = styled.div<{ color?: string }>`
  padding: 8px;
  background-color: ${({ color, theme }) =>
    theme.token.colorPrimaryActive || color || "red"};
  border-radius: 8px;
  height: 30px;
  min-width: 30px;
  color: white;
  cursor: default;
  font-size: 12px;

  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: 768px) {
    height: 40px;
    min-width: 40px;
    span {
      font-size: 14px;
    }
  }
`;
